<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Аннулирование квоты') }}</h1>
    <div class="my-organization">
      <div v-cloak class="quotas-pg create-quota-pg bgw-pdg-20">
        <h4 class="text-center">{{ $t('Аннулирование квоты на добычу диких животных') }}</h4>
        <div class="search-head">
          <v-row>
            <v-col cols="12" sm="4" md="4" :class="{ invalid: $v.quotaCancellation.oopt.$error }">
              <v-label>{{ $t('Организация') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="oopts"
                  item-value="id"
                  item-text="transName"
                  v-model="quotaCancellation.oopt"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                  @change="ooptChangeHandler"
                />
              </div>
            </v-col>
          </v-row>
        </div>
        <v-form
          ref="form"
          lazy-validation
          enctype="multipart/form-data"
          @submit.prevent="createCancelQuotas"
        >
          <!--таблица-->
          <div v-if="faunaQuotas.length" class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td>{{ $t('Вид животного') }}</td>
                <td class="text-center">{{ $t('Лимит') }}</td>
                <td class="text-center">{{ $t('Кол-во гол. выданных ранее') }}</td>
                <td class="text-center">{{ $t('Кол-во использованных') }}</td>
                <td class="text-center">{{ $t('Аннулировать голов') }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in faunaQuotas" :key="item.id">
                <td>{{ item.faunaName }}</td>
                <td class="text-center">{{ item.headQuantity }}</td>
                <td class="text-center">{{ item.headQuantityQuota }}</td>
                <td class="text-center">0</td>
                <td class="text-center">
                  <div>
                    <v-text-field
                      v-model="item.count"
                      type="number"
                      outlined
                      dense
                      class="size-small hide-arrows"
                      @change="faunaCountHandler"
                    />
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <!--Реквизиты документа - Дата-->
          <div class="form-group">
            <div class="quota-fields justify-space-between align-start">
              <div class="quota-field textarea-field">
                <label>{{ $t('Реквизиты документа') }}:</label>
                <v-textarea
                  v-model="quotaCancellation.documentsDetails"
                  outlined
                  dense
                  class="size-small"
                />
              </div>
              <div class="quota-field datepicker-main" :class="{ invalid: $v.quotaCancellation.date.$error }">
                <label>{{ $t('Дата') }}:</label>
                <div class="form-date">
                  <v-icon class="date-icon">date_range</v-icon>
                  <VueCtkDateTimePicker
                    v-model="quotaCancellation.date"
                    format="DD.MM.YYYY"
                    formatted="LL"
                    :onlyDate="true"
                    :label="$t('Дата')"
                    :minDate="minDate"
                    :maxDate="maxDate"
                    :autoClose="true"
                    :noButton="true"
                  />
                </div>
              </div>
            </div>
          </div>
          <!--Файл-->
          <div class="form-group">
            <div class="file-input-link upload-file">
              <v-file-input
                :label="$t('Загрузить файл документа')"
                v-model="quotaCancellationFile"
                clearable
                ref="file"
                @change="handleFileUpload()"
              />
            </div>
          </div>
          <!--Комментарии-->
          <div class="form-group">
            <div class="comment-field">
              <label>{{ $t('Комментарии') }}:</label>
              <v-textarea
                v-model="quotaCancellation.comment"
                outlined
                dense
                class="size-small"
              />
            </div>
          </div>
          <!--кнопки действии-->
          <div class="form-action">
            <button
              class="btn btn-default blue"
              type="submit"
              @click="statusId = 1"
            >
              {{ $t('Сохранить') }}
            </button>
            <button
              class="btn btn-default blue"
              type="submit"
              @click="statusId = 2"
            >
              {{ $t('Сохранить и утвердить') }}
            </button>
            <button
              class="btn btn-default gray"
              type="button"
              @click="onCancel"
            >
              {{ $t('Отмена') }}
            </button>
          </div>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Quota from '@/model/quota'
import Limit from '@/model/limit'
import { required } from 'vuelidate/lib/validators'

export default {
  data: () => ({
    breadcrumbs: [],
    oopts: [],
    quotaCancellation: {
      documentDetails: '',
      comment: ''
    },
    faunaQuotas: [],
    file: '',
    quotaCancellationFile: null,
    statusId: null,
    rules: {
      quotaCancellation: {
        oopt: { required },
        date: { required }
      }
    }
  }),
  validations () {
    return this.rules
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  computed: {
    minDate () {
      const year = new Date().getFullYear()
      return year + '-01-01'
    },
    maxDate () {
      const year = new Date().getFullYear()
      return year + '-12-31'
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Quota.getQuotaCanceledFormData()
        .then((response) => {
          this.oopts = response.data.oopts
          this.generateBreadcrumbs()
          this.setLoading(false)
        })
        .catch((error) => {
          console.log(error)
          this.setLoading(false)
        })
    },
    // Как только выбирается организация, получаем список лимитов по оопт и году
    ooptChangeHandler () {
      this.setLoading(true)
      Limit.getLimitListByOoptYearWithQuota(this.quotaCancellation.oopt, this.$route.query.yearId)
        .then((response) => {
          this.faunaQuotas = response.data
          this.setLoading(false)
        })
        .catch((error) => {
          console.log(error)
          this.setLoading(false)
        })
    },
    // создание квоты на аннулирование
    createCancelQuotas () {
      if (!this.validateForm()) {
        return
      }
      const formEl = this.$refs.form.$el
      const fd = new FormData(formEl)
      fd.append('quota_canceled[oopt]', this.quotaCancellation.oopt)
      fd.append('quota_canceled[documentDetails]', this.quotaCancellation.documentDetails)
      fd.append('quota_canceled[date]', this.quotaCancellation.date)
      fd.append('quota_canceled[uploadedFile]', this.quotaCancellationFile)
      fd.append('quota_canceled[comment]', this.quotaCancellation.comment)

      const result = []
      this.faunaQuotas.map(element => {
        if (element.count > 0) {
          result.push({
            id: element.faunaId,
            count: element.count
          })
        }
      })
      result.forEach(function (element, index) {
        fd.append('faunas[' + index + '][id]', element.id)
        fd.append('faunas[' + index + '][count]', element.count)
      })
      if (result.length === 0) {
        this.$noty.error(this.$i18n.t('Необходимо указать "Аннулировать голов" хотя бы для одного вида животного'), {
          killer: true,
          timeout: 2000,
          layout: 'topRight'
        })
        return
      }

      this.setLoading(true)
      Quota.createCancelQuotas(this.$route.query.yearId, this.statusId, fd).then((response) => {
        this.onCancel()
        this.setLoading(false)
      }).catch((error) => {
        console.log(error)
        this.setLoading(false)
      })
    },
    // проверяем поле "аннулировать голов" поле не должно быть меньше 0 и превышать "количество выданных ранее"
    faunaCountHandler () {
      this.faunaQuotas.forEach((element) => {
        if (element.count > element.headQuantityQuota) {
          element.count = element.headQuantityQuota
          this.$noty.error(this.$i18n.t('Количество аннулировать голов не должно превышать, количество выданных ранее'), {
            killer: true,
            timeout: 2000,
            layout: 'topRight'
          })
        }
        if (element.count < 0) {
          element.count = 0
        }
      })
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Заявки на квоты'),
          disabled: false,
          href: '/quotas'
        },
        {
          text: this.$i18n.t('Аннулирование квоты'),
          disabled: true
        }
      ]
    },
    // загрузка файла
    handleFileUpload () {
      this.file = ''

      if (this.quotaCancellationFile) {
        this.createFile(this.quotaCancellationFile)
      }
    },
    createFile (file) {
      const reader = new FileReader()
      const vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'quotas'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-head {
  margin-bottom: 20px;
}

.table-overflow {
  margin-bottom: 30px;

  table {
    td {
      .v-input {
        margin: 0 auto;
      }
    }
  }
}

.datepicker-main {
  flex-wrap: wrap;
}

.hint {
  width: 100%;
}
</style>
